module.exports = __webpack_public_path__ + "static/media/sound.282a5608.svg";